import React from 'react';

export default function Contact() {
    return (
        <div className="Page">
            <h1>Contact page</h1>
        </div>
    );
}
